import { Checkbox, CheckboxGroup, Stack } from '@chakra-ui/react';
import { sortBy } from 'lodash';
import { useMemo } from 'react';

import { getColumns } from '../../Dashboard/DashboardWidget/widgetUtils';
import { getColumnLabel } from '../../utils/tableUtils';

export const ColumnSelector = ({
    widgetType,
    columnIds,
    setColumnIds,
}: {
    widgetType: DashboardWidgetType;
    columnIds: string[];
    setColumnIds: (values: string[]) => void;
}) => {
    const columns = useMemo(() => {
        return sortBy(
            getColumns(widgetType).map((col) => {
                return {
                    id: col.id,
                    label: typeof col.header === 'string' ? col.header : getColumnLabel(col.id!),
                };
            }),
            'label',
        );
    }, [widgetType]);

    return (
        <CheckboxGroup colorScheme="teal" value={columnIds} onChange={setColumnIds}>
            <Stack gap={0} flexWrap="wrap" maxH="500px">
                {columns.map((column) => (
                    <Checkbox key={column.id} value={column.id}>
                        {column.label}
                    </Checkbox>
                ))}
            </Stack>
        </CheckboxGroup>
    );
};
